import { stegaClean } from './stega';

/** `tel:` target for a formatted phone number — spaces, slashes and dashes are
 *  presentation, the dial string is not. */
export function telHref(phone: string): string {
    return `tel:${stegaClean(phone).replace(/[^+\d]/g, '')}`;
}

/** Postal address on one line: „Straße · PLZ Ort“, leaving out the parts that are empty. */
export function addressLine(street?: string, zip?: string, city?: string): string {
    return [street, [zip, city].filter(Boolean).join(' ')].filter((part) => Boolean(part && part.trim())).join(' · ');
}

/** `mailto:` target for a stored address. */
export function mailtoHref(email: string): string {
    return `mailto:${stegaClean(email).trim()}`;
}
